import React from "react";
import clsx from "clsx";
import { options, statusChipStyle } from '@univdiam/ui/lib/StatusOptions';



interface StatusBadgeProps {
    status: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
    const match = options.find(opt => opt.id === status);
    if (!match) return null;

    return (
        // The colours are hex values, not class names, so they go in style.
        <div
            className={clsx(
                "inline-flex items-center gap-1 px-2 py-1 rounded-md border caption",
                "text-black"
            )}
            style={statusChipStyle(status)}
        >
            {/* {match.icon} */}
            {match.label}
        </div>
    );
};
